export default [
  {
    path: '/recuperar-senha',
    name: 'recuperar-senha',
    component: () => import('./index')
  }
]
